import o from "./ghl-ui.es770.js";
var r = o["__core-js_shared__"];
const t = r;
export {
  t as default
};
